
















import Vue from 'vue';
import {Component} from "vue-property-decorator";
import axiosInstance from "../../../axios";
import {CodeData} from "../../../../types";

@Component({
    components: {},
    props: {}
})

export default class CodeList extends Vue {
    private codeList: Array<CodeData> = [];

    mounted(): void
    {
        this.getCodeList();
    }

    /**
     * Получить список кодов
     * @private
     */
    private getCodeList(): void
    {
        axiosInstance.get('/profile/code/list')
            .then(response => {
                if (response.data.response) {
                    this.codeList = response.data.response;
                }
            });
    }

    /**
     * Купить новый код
     * @private
     */
    private buyNewCode(): void
    {
        axiosInstance.post('/profile/code/buy-new-code', {})
            .then(response => {
                if (response.data.response) {
                    this.getCodeList();
                }
            });
    }
}
